export default {
  API_URL: "https://api.rmc.ai/",
  PLATFORM_URL: "https://api.rmc.ai/",
  //API_URL: "http://localhost:4000/",
  //PLATFORM_URL: "http://localhost:5000/",
  AUTH_URL: "https://api.rmc.ai/",
  DEFAULT_PAGE_SIZE: 20,
  DEBUG: 0,
  PLATFORM_ROLE: { admin: "PLATFORM_ADMIN", user: "PLATFORM_USER", none: "NONE" },
  IOT_ROLE: { admin: "IOT_ADMIN", user: "IOT_USER", none: "NONE" },
  //APP:"IOT"
  APP:"ANOMALY"
};
